import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubCategory, SubCategoryCollection } from '../interfaces';
import { ApiService } from './api.service';

export type SubCategoryFilters = {
  categorie_id?: string | number
  nom?: string
  order_by?: string;
  order?: string;
  page?: number;
  size?: number;
  fields?: {
    'sous_categories'?: string;
  }
  [x: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SubCategoryService extends ApiService {

  public get(id: string | number, filters: SubCategoryFilters = {}): Observable<SubCategory> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.get<SubCategory>(`${this.apiUrl}/sous-categories/${id}${queryString}`)
    }
  
    public getCollection(filters: SubCategoryFilters = {}): Observable<SubCategoryCollection> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.get<SubCategoryCollection>(`${this.apiUrl}/sous-categories/${queryString}`)
    }
  
    public post(data: Partial<SubCategory>, filters: SubCategoryFilters = {}): Observable<SubCategory> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.post<SubCategory>(`${this.apiUrl}/sous-categories/${queryString}`, data)
    }
  
    public patch(id: string | number, data: Partial<SubCategory>, filters: SubCategoryFilters = {}): Observable<SubCategory> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.patch<SubCategory>(`${this.apiUrl}/sous-categories/${id}${queryString}`, data)
    }
  
    public delete(id: string | number): Observable<string> {
      return this.http.delete<string>(`${this.apiUrl}/sous-categories/${id}`)
    }
}
